/* @refresh reload */
import { render } from 'solid-js/web';
import './index.css';
import './assets/styles.less';
import App from './App';
const appData = JSON.parse((document.getElementById("solid-app-data") as HTMLInputElement)?.innerHTML || "{}") as any;
render(() => <App id={appData.id} googleMapsApiKey={appData.googleMapsApiKey} />, document.getElementById('root'));